const paymentAmountReducer = (state = 0, action) => {
	switch(action.type){
	case 'NEWPAYMENTAMOUNT':	
		return action.payload;
	default:
		return state;
	}
}

export default paymentAmountReducer;